<template>
  <div class="app-container">
    <keep-alive>
      <item :columnData="columnData" :is-activated="isActivated" :routeName="routeName" :menuName="menuName" :titleName="titleName" :parent="parent" :tab="tab" currentIndex = "5"></item>
    </keep-alive>
  </div>
</template>
<script>
import Item from './components/Item'
let isPageActivated = false
export default {
  name: 'budgetExamine',
  components: {Item},
  data () {
    return {
      isActivated: false,
      parent: 'budgetExamine',
      columnData: [{
        type: 'selection',
        width: '40'
      }, {
        field: 'operate',
        title: '操作',
        width: '120',
        isDefine: true,
        child: [{
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '详情',
          methodName: 'on-detail',
          type: 'btn'
        }, {
          type: 'btn',
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '管理',
          methodName: 'on-manage'
        }, {
          type: 'btn',
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
          title: '消息',
          methodName: 'on-message'
        }]
      }, {
        type: 'index',
        title: '序号',
        width: '60'
      }, {
        field: 'businessStatus',
        title: '业务状态',
        width: '120'
      }, {
        field: 'lastLog',
        title: '客户日志',
        width: '200'
      }, {
        field: 'designDelayTime',
        title: '平面出图时间',
        width: '200'
      }, {
        field: 'effectDelayTime',
        title: '效果出图时间',
        width: '200'
      }, {
        field: 'photoStatusStr',
        title: '效果图',
        width: '200'
      }, {
        field: 'customerNumber',
        title: '客户编号',
        width: '140'
      }, {
        field: 'name',
        title: '客户名字',
        width: '80'
      }, {
        field: 'telephone',
        title: '客户电话',
        width: '100'
      }, {
        field: 'detailedAddress',
        title: '装修地点',
        width: '250'
      }, {
        field: 'customerAssign.beName',
        title: '预算员',
        width: '80'
      }, {
        field: 'customerAssign.beDepartmentName',
        title: '预算部',
        width: '100'
      }, {
        field: 'customerAssign.salesmanName',
        title: '业务员',
        width: '80'
      }, {
        field: 'customerAssign.salesmanDepartmentName',
        title: '业务部',
        width: '100'
      }, {
        field: 'customerAssign.cmName',
        title: '客户经理',
        width: '80'
      }, {
        field: 'customerAssign.cmDepartmentName',
        title: '客服部',
        width: '100'
      }, {
        field: 'customerAssign.designerName',
        title: '设计师',
        width: '80'
      }, {
        field: 'customerAssign.designerDepartmentName',
        title: '设计部',
        width: '100'
      }, {
        field: 'customerAssign.houseName',
        title: '全屋设计师',
        width: '100'
      }, {
        field: 'customerAssign.houseDepartmentName',
        title: '全屋设计部',
        width: '100'
      }, {
        field: 'customerAssign.electricName',
        title: '电器设计师',
        width: '100'
      }, {
        field: 'customerAssign.electricDepartmentName',
        title: '电器设计部',
        width: '100'
      }, {
        field: 'customerAssign.softName',
        title: '软装设计师',
        width: '100'
      }, {
        field: 'customerAssign.softDepartmentName',
        title: '软装设计部',
        width: '100'
      }, {
        field: 'customerAssign.assistantName',
        title: '设计助理',
        width: '100'
      }, {
        field: 'customerAssign.assistantDepartmentName',
        title: '设计助理部',
        width: '100'
      }, {
        field: 'customerAssign.emName',
        title: '工程部经理',
        width: '100'
      }, {
        field: 'customerAssign.emDepartmentName',
        title: '工程部',
        width: '100'
      }, {
        field: 'budgetExamineTime',
        title: '提交预算时间',
        width: '200',
        formatter: ['toDateString', 'yyyy-MM-dd']
      }],
      routeName: '',
      menuName: '',
      titleName: '',
      tab: [{
        name: '我的预算审核',
        nickName: 'submitBudgetExamine',
        timeName: '预算',
        startTName: 'budgetExamineStartTime',
        endTName: 'budgetExamineEndTime',
        type: 1
      }, {
        name: '待审核',
        nickName: 'submitBudgetExamine',
        timeName: '预算',
        startTName: 'budgetExamineStartTime',
        endTName: 'budgetExamineEndTime',
        type: 2,
        status: 1
      }, {
        name: '已审核',
        nickName: 'submitBudgetExamine',
        timeName: '预算',
        startTName: 'budgetExamineStartTime',
        endTName: 'budgetExamineEndTime',
        type: 2,
        status: 2
      }, {
        name: '未通过',
        nickName: 'submitBudgetExamine',
        timeName: '预算',
        startTName: 'budgetExamineStartTime',
        endTName: 'budgetExamineEndTime',
        type: 2,
        status: 3
      }, {
        name: '结算变更',
        nickName: 'submitBudgetExamine',
        timeName: '预算',
        startTName: 'budgetExamineStartTime',
        endTName: 'budgetExamineEndTime',
        type: 2,
        status: 4
      }]
    }
  },
  created () {
    this.routeName = this.$route.name
    this.menuName = this.$route.meta.nickName
    this.titleName = this.$route.meta.title
  },
  beforeRouteEnter (to, from, next) {
    if (from.meta) {
      /**
       * isActivated: true --> 后退而来
       * isActivated：false --> 其他页面跳转来
       */
      isPageActivated = from.meta.isActivated || false
    }
    next()
  },
  activated () {
    this.isActivated = isPageActivated
  },
  beforeRouteLeave (to, from, next) {
    if (!to.meta.isAlone) {
      this.isActivated = false
    }
    next()
  },
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/customer/budgetExamine.vue